export {default} from './CandidatesSection.connect';
